/**
 * Convert a category name into a stable ASCII slug.
 *
 * IMPORTANT: This algorithm MUST stay in sync with the PHP version used by
 * HandleInertiaRequests::slugifyCategoryName(). Both implementations are used
 * together — backend generates slugs for the nav dropdown links, frontend
 * regenerates them on the product page to attach as anchor ids.
 */
export function slugifyCategoryName(name: string, fallbackId?: number | string): string {
  const replacements: Record<string, string> = {
    'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss',
    'Ä': 'Ae', 'Ö': 'Oe', 'Ü': 'Ue',
  }

  const normalized = name.replace(/[äöüßÄÖÜ]/g, (char) => replacements[char] ?? char)

  const slug = normalized
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip combining diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

  if (slug !== '') {
    return slug
  }

  return fallbackId !== undefined ? `category-${fallbackId}` : 'category'
}

/**
 * Build the DOM id used for the anchor target on the products page.
 */
export function categoryAnchorId(name: string, fallbackId?: number | string): string {
  return `category-${slugifyCategoryName(name, fallbackId)}`
}
